import { beforeEnterHasPerm } from '@/components/PermissionHelper'

const beforeEnter = (to, from, next) => { return beforeEnterHasPerm(to, from, next) }

const ROUTES = {
  EQUAL_ORGANIZATION_LIST: 'miscellaneous-equal-organization'
}

const routes = [
  {
    path: 'equal-organization/',
    name: ROUTES.EQUAL_ORGANIZATION_LIST,
    beforeEnter: beforeEnter,
    props: true,
    meta: {
      permissions: ['miscellaneous_equalorganization_list'],
      requiresAuth: true
    },
    component: () => import('./EqualOrganizationList.vue')
  }

]

export { routes, ROUTES }
